import { render, staticRenderFns } from "./SRCDetail.vue?vue&type=template&id=2c27ed87&"
import script from "./SRCDetail.vue?vue&type=script&lang=js&"
export * from "./SRCDetail.vue?vue&type=script&lang=js&"
import style0 from "./SRCDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports